import axios from 'axios';
import { mockApi } from './mockApi';

const axiosAPI = axios.create({
  baseURL: 'https://api.repack.no/',
  headers: {
    Pragma: 'no-cache'
  },
  timeout: 5000
});

const successHandler =
  ({ fallbackReturnValue }) =>
  ({ data }) => {
    return data || fallbackReturnValue;
  };

const getHandlers = (method, url, customOptions, data) => {
  if (process.env.REACT_APP_ENV !== 'production') {
    return mockApi(url);
  }

  const defaultOptions = {
    defaultSuccessHandler: true,
    fallbackReturnValue: {},
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  };

  const { defaultSuccessHandler, ...options } = {
    ...defaultOptions,
    ...customOptions
  };

  return axiosAPI({ method, url, data, ...options }).then(
    defaultSuccessHandler ? successHandler(options) : undefined
  );
};

export default {
  get: (url, customOptions) => getHandlers('get', url, customOptions),
  post: (url, data, customOptions) =>
    getHandlers('post', url, customOptions, data),
  put: (url, data, customOptions) =>
    getHandlers('put', url, customOptions, data),
  delete: (url, customOptions) => getHandlers('delete', url, customOptions)
};
